module.exports = __webpack_public_path__ + "static/media/data_sharing.fb4c2fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/data_sharing.png
// module id = 258
// module chunks = 0